import { render, staticRenderFns } from "./visitPerson.vue?vue&type=template&id=53f2d112&scoped=true&"
import script from "./visitPerson.vue?vue&type=script&lang=js&"
export * from "./visitPerson.vue?vue&type=script&lang=js&"
import style0 from "./visitPerson.vue?vue&type=style&index=0&id=53f2d112&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f2d112",
  null
  
)

export default component.exports